module.exports = __webpack_public_path__ + "img/5.2.35129ce9.png";